module.exports = __webpack_public_path__ + "img/saireddy.6bfe4c64.webp";